var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeroSkyline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 720,
    viewBox: "0 0 1200 720",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 720,
    fill: "transparent"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 620H78V470H118V540H154V412H210V620H254V365H300V620H356V430H392V502H430V620H478V338H532V620H580V465H618V398H658V620H708V350H754V620H810V442H848V502H886V620H942V390H988V620H1038V458H1074V416H1112V620H1200V720H0V620Z",
    fill: "#3A4558"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 650H66V558H102V650H150V486H198V650H246V520H276V650H340V444H388V650H450V536H478V650H538V474H572V650H648V412H694V650H748V512H780V650H842V450H886V650H958V498H992V650H1042V530H1070V650H1144V562H1180V650H1200V720H0V650Z",
    fill: "#556176"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86 502H95V511H86V502Z",
    fill: "#92A3BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167 438H176V447H167V438Z",
    fill: "#92A3BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178 456H187V465H178V456Z",
    fill: "#92A3BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263 392H272V401H263V392Z",
    fill: "#92A3BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263 410H272V419H263V410Z",
    fill: "#92A3BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491 360H500V369H491V360Z",
    fill: "#92A3BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491 380H500V389H491V380Z",
    fill: "#92A3BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491 400H500V409H491V400Z",
    fill: "#92A3BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722 372H731V381H722V372Z",
    fill: "#92A3BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722 392H731V401H722V392Z",
    fill: "#92A3BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722 412H731V421H722V412Z",
    fill: "#92A3BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M957 426H966V435H957V426Z",
    fill: "#92A3BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M957 446H966V455H957V446Z",
    fill: "#92A3BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1078 448H1087V457H1078V448Z",
    fill: "#92A3BA"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroSkyline);
export default __webpack_public_path__ + "static/media/hero-skyline.39c8fde5b29b353e7a7f20ce99a407b0.svg";
export { ForwardRef as ReactComponent };